<template>
    <div class="col-md-12">
        <div class="h2">Locked products</div>
        <div class="pt-3">
            <form @submit.prevent="updateLockedProducts">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                        <thead>
                        <tr>
                            <th class="border-right text-left">
                                Client
                            </th>
                            <th class="border-right text-left">
                                Agreement
                            </th>
                            <th class="border-right text-left">
                                Lock products/services
                            </th>
                        </tr>
                        </thead>
                        <tbody class="table-bordered">
                        <tr v-for="agreement in agreements">
                            <td class="text-left" style="width: 15%">
                                {{ agreement.client.name }}
                            </td>
                            <td class="text-left" style="width: 15%">
                                {{ agreement.name }}
                            </td>
                            <td class="text-left" style="width: 15%">
                                <label class="newInput">
                                    <input
                                        type="checkbox"
                                        v-model="lockedProducts[agreement.id]"
                                    >
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-md-12 d-flex justify-content-left align-items-center mt-3">
                        <button type="submit" class="btn btn-success mr-2">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "LockedProducts",
    props: {
        url: {type: String, required: true}
    },
    data() {
        return {
            lockedProducts: {},
            agreements: {},
        }
    },
    methods: {
        updateLockedProducts() {
            axios.post(`/settings/locked-products`, this.lockedProducts).then((response) => {
                window.location.href = `/settings/locked-products`;
            }).catch(err => console.log(err))
        },
        fetchData() {
            axios.get(this.url)
                .then(({data}) => {
                    this.agreements = data.data
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.lockedProducts[value.id] = value.is_locked_products;
                    });
                })
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>
<style>

</style>
